import * as React from "react";
import { DropdownMenu, IconButton } from "@radix-ui/themes";
import { ChatBubbleIcon, Pencil2Icon, ReaderIcon } from "@radix-ui/react-icons";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { useCommonDialogs } from "../../CommonDialogsProvider.tsx";

interface Props {
  itemId: Id<"items">;
}

export const ItemChatMenuItem: React.FC<Props> = ({ itemId }) => {
  const dialogs = useCommonDialogs();
  return (
    <>
      <DropdownMenu.Item onClick={() => dialogs?.openItemChat({ itemId })}>
        <ChatBubbleIcon />
        Chat about it
      </DropdownMenu.Item>
    </>
  );
};
